// extracted by mini-css-extract-plugin
module.exports = {"dialogActions":"styles_dialogActions__DpoTJ"};